import script from './SdsEmptyScreen.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sds-empty-screen",class:{
        'sds-empty-screen--colored': _vm.background === 'color',
    }},[(_vm.illustrationName)?_c('SdsIllustration',{attrs:{"illustrationName":_vm.illustrationName,"size":"md"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"sds-empty-screen__text"},[(_vm.title)?_c('div',{staticClass:"sds-empty-screen__title"},[_vm._v("\n            "+_vm._s(_vm.title)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.hasDescription)?_c('div',{staticClass:"sds-empty-screen__description"},[_vm._t("description",function(){return [_vm._v("\n                "+_vm._s(_vm.description)+"\n            ")]})],2):_vm._e()]),_vm._v(" "),(_vm.hasActions)?_c('div',{staticClass:"sds-empty-screen__buttons"},[_vm._t("secondary-action",null,{"attrs":_vm.secondaryActionAttrs,"on":_vm.secondaryActionHandlers}),_vm._v(" "),_vm._t("primary-action",null,{"attrs":_vm.primaryActionAttrs,"on":_vm.primaryActionHandlers})],2):_vm._e()],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-448a3356_0", { source: ".sds-empty-screen[data-v-448a3356]{--component-empty-screen-title-color:var(--system-text-on-elevation-primary);--component-empty-screen-description-color:var(--system-text-on-elevation-tertiary);display:flex;flex-direction:column;gap:16px;align-items:center;justify-content:center;height:100%}.sds-empty-screen__text[data-v-448a3356]{display:flex;flex-direction:column;gap:8px;text-align:center;max-width:50ch}.sds-empty-screen__title[data-v-448a3356]{font-family:var(--system-title-default-family);font-size:var(--system-title-default-size);font-weight:700;line-height:var(--system-title-default-line-height);letter-spacing:var(--system-title-default-letter-spacing);text-transform:uppercase;text-wrap:balance;color:var(--component-empty-screen-title-color)}.sds-empty-screen__description[data-v-448a3356]{margin:0;padding:0;font-weight:400;font-size:14px;line-height:1.38462;text-wrap:pretty;color:var(--component-empty-screen-description-color)}.sds-empty-screen__buttons[data-v-448a3356]{display:flex;gap:12px;justify-content:center;flex-wrap:wrap-reverse}.sds-empty-screen--colored[data-v-448a3356]{--component-empty-screen-title-color:var(--system-text-on-color-primary);--component-empty-screen-description-color:var(--system-text-on-color-secondary)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-448a3356";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
